import { useEffect } from 'react';

export default (config: { [key: string]: (event?: KeyboardEvent) => void }): void => {
  const handleKeyPress = (e) => {
    if (config[e.key]) {
      config[e.key]();
    }
  };

  useEffect(() => {
    document.addEventListener('keyup', handleKeyPress);

    return () => {
      document.removeEventListener('keyup', handleKeyPress);
    };
  }, [config]);
};
